var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16C0 7.16345 7.16345 0 16 0C24.8366 0 32 7.16345 32 16C32 24.8366 24.8366 32 16 32C7.16345 32 0 24.8366 0 16Z",
    fill: "#330072"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55159 7.92659C9.96886 7.50932 10.5348 7.2749 11.1249 7.2749H16.8124C16.9715 7.2749 17.1241 7.33812 17.2367 7.45064L22.9242 13.1381C23.0367 13.2507 23.0999 13.4033 23.0999 13.5624V22.4999C23.0999 23.09 22.8655 23.6559 22.4482 24.0732C22.0309 24.4905 21.465 24.7249 20.8749 24.7249H11.1249C10.5348 24.7249 9.96886 24.4905 9.55159 24.0732C9.13432 23.6559 8.8999 23.09 8.8999 22.4999V9.4999C8.8999 8.9098 9.13432 8.34386 9.55159 7.92659ZM11.1249 8.4749C10.8531 8.4749 10.5923 8.58289 10.4001 8.77512C10.2079 8.96734 10.0999 9.22806 10.0999 9.4999V22.4999C10.0999 22.7717 10.2079 23.0325 10.4001 23.2247C10.5923 23.4169 10.8531 23.5249 11.1249 23.5249H20.8749C21.1467 23.5249 21.4075 23.4169 21.5997 23.2247C21.7919 23.0325 21.8999 22.7717 21.8999 22.4999V13.8109L16.5639 8.4749H11.1249Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8124 7.2749C17.1438 7.2749 17.4124 7.54353 17.4124 7.8749V12.9624H22.4999C22.8313 12.9624 23.0999 13.231 23.0999 13.5624C23.0999 13.8938 22.8313 14.1624 22.4999 14.1624H16.8124C16.481 14.1624 16.2124 13.8938 16.2124 13.5624V7.8749C16.2124 7.54353 16.481 7.2749 16.8124 7.2749Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.77c6f5e3f8441a3d0a347e533099665e.svg";
export { ForwardRef as ReactComponent };